<template>
  <div class="container">
    <div v-show="deviceState === 'denied'" style="padding: 2vh">
      <div style="color: #e74a23; border: 1px solid #e74a23;width: fit-content;margin: 0 auto;padding: 1vh;border-radius: 1vh;">
        <div style="font-size: 2.5vh;font-weight: bold">
          <span class="warning" style="top:-0.3vh;position: relative;display: inline-block;">warning</span>
        </div>
        <div>
          カメラ<span v-show="needDevice.audio">かマイク</span>へのアクセスが拒否されています。<br/>
          URL欄あたりで再度許可できたりします（ブラウザによって異なります）
        </div>
      </div>
    </div>
    <div v-show="deviceState === 'waitCamera'" style="padding: 2vh">
      <div class="waitCamera">
        <div v-show="isMobile || isSafari" class="mobile-warning" style="color: #e74a23; border: 1px solid #e74a23;width: fit-content;margin: 0 auto;padding: 1vh;border-radius: 1vh;">
          <div style="font-size: 2.5vh;font-weight: bold">
            <span class="warning" style="top:-0.3vh;position: relative;display: inline-block;">warning</span>
          </div>
          <div v-if="isMobile">
            スマートフォン・タブレットではスムーズに動作しない可能性が高いです
          </div>
          <div v-else-if="isSafari">
            Safariではスムーズに動作しない可能性が高いです
          </div>
        </div>
        <basic-button label="スタート" icon="directions_run" @click="start" />
        <div style="color: #e74a23; border: 4px solid #e74a23; width: fit-content; margin: 0 auto; padding: 2vh; border-radius: 2vh ">
          <div>
            ブラウザが以下の許可をリクエストします
          </div>
          <ul style="width: fit-content;margin: 0 auto;padding: 2vh;">
            <li class="device-li">Webカメラ</li>
            <li v-show="needDevice.audio" class="device-li">マイク</li>
          </ul>
          <div>
            「許可」するとスタートします
            <div style="font-size: 90%;margin-top: 1vh">（映像はこのPC/スマホで処理され、外部には送られません）</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="deviceState === 'ready'">
      <div v-show="cameraState === 'init'" class="noto300" style="text-align: center;margin: 0 auto;margin-top: 40vh;color: #ec841b;font-size: 5vh;">
        準備中
        <pulse-loader color="#ec841b" size="5vh" margin="5vh" />
        <div style="text-align: center;margin: 0 auto">
        </div>
      </div>
      <div v-show="cameraState === 'ready'">
        <canvas id="camera-canvas" class="main-canvas" :class="isWipe ? 'wipe' : ''"></canvas>
        <canvas id="physics-canvas" v-show="physics" class="main-canvas"></canvas>
        <video id="video" playsinline></video>
        <div id="scatter-gl-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import RingLoader from "vue-spinner/src/RingLoader.vue";
import RiseLoader from 'vue-spinner/src/RiseLoader'
import FadeLoader from 'vue-spinner/src/FadeLoader'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import BasicButton from "./common/BasicButton";
import CommonModal from "./common/CommonModal";
import {FitUtil} from "./common/FitUtil";
export default {
  name: "FillCameraLayout",
  components: {CommonModal, BasicButton, RingLoader, PulseLoader, RiseLoader, FadeLoader, BeatLoader },
  props: {
    isWipe: {
      type: Boolean,
      default: false,
    },
    deviceState: {
      type: String
    },
    cameraState: {
      type: String
    },
    physics: {
      type: Boolean,
      default: false
    },
    needDevice: {
      type: Object,
      default() { return {} },
    }
  },
  data() {
    return {
      isSafari: FitUtil.isSafari(),
      isMobile: FitUtil.isMobile(),
    }
  },
  mounted() {
    // $("#demo01").animatedModal();
  },
  methods: {
    start() {
      this.$emit('camera-required')
    },
    openModal() {
      this.$refs['modal'].$emit('open-modal')
    },
  }
}
</script>

<style scoped>
.main-canvas {
  position: absolute;
  top:10vh;
  left: 0;
  width: 100vw;
  height: 90vh;
}
#video {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  visibility: hidden;
  width: auto;
  height: auto;
}
.waitCamera {
  height: 100vh;
  margin-top: 10vh;
}
.device-li {
  text-align: left;
  margin: 1vh 0;
}
.wipe {
  right: 0;
  left: 80vw;
  width: 20vw;
  height: auto;
  bottom: 0;
  top: auto;
}
.warning {
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 3.5vh;
}
</style>



// WEBPACK FOOTER //
// src/components/FillCameraLayout.vue